export default "__VITE_ASSET__CLpLMxrp__"